// extracted by mini-css-extract-plugin
export default {"section":"Faq_section__Pc6yc","subtitle":"Faq_subtitle__JE7t+","content":"Faq_content__O2Wi5","link":"Faq_link__NF0LC"};